import { PRESCRIPTION_TYPES } from 'shared/consts/productTemplates'

/**
 * PrescriptionTypes definitions and as a collection
 */
export const PRESCRIPTION_TYPE_NO_PRESCRIPTION: string = 'noPrescription'
export const PRESCRIPTION_TYPE_INSURANCE: string = 'insurancePrescription'
export const PRESCRIPTION_TYPE_FREE: string = 'freePrescription'
export const PRESCRIPTION_TYPE_PRIVAT: string = 'privatePrescription'
export const PRESCRIPTION_TYPE_ODS: string = 'odsSection'
export const PRESCRIPTION_TYPE_ERX: string = 'electronicPrescription'

export type PrescriptionType =
  typeof PRESCRIPTION_TYPES[keyof typeof PRESCRIPTION_TYPES]
